export default "__VITE_ASSET__b2498c55__"